import React from 'react';
import { Button, Typography } from 'antd';
import { CloseCircleFilled, ReloadOutlined, HomeOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const { Title, Text } = Typography;

const Container = styled.div`
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  padding: 24px;
`;

const Content = styled.div`
  text-align: center;
  max-width: 480px;
`;

const IconWrapper = styled.div`
  margin-bottom: 24px;

  .anticon {
    font-size: 64px;
    color: #e84749;
  }
`;

const StyledTitle = styled(Title)`
  color: rgba(255, 255, 255, 0.85) !important;
  margin-bottom: 12px !important;
`;

const StyledText = styled(Text)`
  color: rgba(255, 255, 255, 0.45);
  font-size: 14px;
  display: block;
  margin-bottom: 32px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <Content>
            <IconWrapper>
              <CloseCircleFilled />
            </IconWrapper>
            <StyledTitle level={3}>Something went wrong.</StyledTitle>
            <StyledText>{this.state.error?.message || 'An unexpected error occurred.'}</StyledText>
            <ButtonGroup>
              <Button type="primary" icon={<ReloadOutlined />} onClick={() => window.location.reload()} size="large">
                Reload Page
              </Button>
              <Button
                icon={<HomeOutlined />}
                onClick={() => {
                  window.location.href = '/broadcast/my';
                }}
                size="large"
              >
                Go to Dashboard
              </Button>
            </ButtonGroup>
          </Content>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
